<template>
  <div class="buttonlist">
    <div class="buttonlist-m">
      <el-form :inline="true" :model="filteForm" class="demo-form-inline toolbar filter-form" @submit.native.prevent>
        <el-form-item label="项目名称">
          <el-input v-model.trim="filteForm.projectName" placeholder="请输入项目名称" clearable style="width:180px" @keyup.enter.native="onSubmit" />
        </el-form-item>
        <el-form-item label="项目分类">
          <el-select v-model="filteForm.category" clearable placeholder="全部" style="width:140px">
            <el-option label="基础护理" value="basic" />
            <el-option label="生活照料" value="life" />
            <el-option label="医疗护理" value="medical" />
            <el-option label="心理护理" value="psychological" />
            <el-option label="安全看护" value="safety" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="filteForm.status" clearable placeholder="全部" style="width:100px">
            <el-option label="启用" :value="1" />
            <el-option label="停用" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" plain @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
      <el-form :inline="true" class="demo-form-inline toolbar action-form">
        <el-form-item>
          <el-button type="warning" plain class="el-icon-plus" @click="showAddForm">新增</el-button>
          <el-button type="info" icon="el-icon-download" plain @click="exportExcel">导出</el-button>
          <el-button type="success" plain icon="el-icon-upload2" @click="triggerImport">导入</el-button>
          <el-button plain @click="downloadTemplate">下载模板</el-button>
          <input ref="importFile" type="file" accept=".xls,.xlsx" style="display:none" @change="onImportFile" />
        </el-form-item>
      </el-form>

      <div v-loading="loading" class="table-wrap">
        <el-table :data="dataList" style="width: 100%" :row-style="tableRowStyle" :header-cell-style="tableHeaderColor">
          <el-table-column label="项目编码" prop="projectCode" align="center" width="150" show-overflow-tooltip />
          <el-table-column label="项目名称" prop="projectName" align="center" min-width="140" show-overflow-tooltip />
          <el-table-column label="分类" align="center" width="100">
            <template slot-scope="scope">{{ categoryText(scope.row.category) }}</template>
          </el-table-column>
          <el-table-column label="价格" align="center" width="100">
            <template slot-scope="scope">
              <span class="price-text">￥{{ formatPrice(scope.row.price) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="默认时长(分)" prop="defaultDuration" align="center" width="110" />
          <el-table-column label="适用性别" align="center" width="90">
            <template slot-scope="scope">{{ genderText(scope.row.gender) }}</template>
          </el-table-column>
          <el-table-column label="状态" align="center" width="80">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="mini">
                {{ scope.row.status === 1 ? '启用' : '停用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="240" fixed="right">
            <template slot-scope="scope">
              <div class="op-cell">
                <el-button type="warning" size="mini" plain @click="handleEdit(scope.row)">编辑</el-button>
                <el-button :type="scope.row.status === 1 ? 'info' : 'success'" size="mini" plain
                  @click="toggleStatus(scope.row)">{{ scope.row.status === 1 ? '停用' : '启用' }}</el-button>
                <el-button type="danger" size="mini" plain @click="handleDelete(scope.row)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background @current-change="handleCurrentChange" :current-page="filteForm.pageNum"
          layout="total, prev, pager, next" :total="totalDataNumber" align="center" class="fenye" />
      </div>

      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="560px" :close-on-click-modal="false" @close="closeDialog">
        <el-form ref="form" :model="addForm" label-width="110px">
          <el-form-item label="项目名称" required>
            <el-input v-model.trim="addForm.projectName" placeholder="请输入项目名称" />
          </el-form-item>
          <el-form-item label="项目分类" required>
            <el-select v-model="addForm.category" placeholder="请选择" style="width:100%">
              <el-option label="基础护理" value="basic" />
              <el-option label="生活照料" value="life" />
              <el-option label="医疗护理" value="medical" />
              <el-option label="心理护理" value="psychological" />
              <el-option label="安全看护" value="safety" />
            </el-select>
          </el-form-item>
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="价格(元)">
                <el-input-number v-model="addForm.price" :min="0" :precision="2" :step="1" :controls="true" style="width:100%" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="默认时长">
                <el-input-number v-model="addForm.defaultDuration" :min="1" :max="480" style="width:100%" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="适用性别">
            <el-select v-model="addForm.gender" style="width:100%">
              <el-option label="全部" value="all" />
              <el-option label="男" value="male" />
              <el-option label="女" value="female" />
            </el-select>
          </el-form-item>
          <el-form-item label="项目描述">
            <el-input v-model.trim="addForm.description" type="textarea" :rows="3" />
          </el-form-item>
        </el-form>
        <div slot="footer" align="center">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" :loading="submitLoading" @click="submitForm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { postDownload } from "@/utils/request.js";
export default {
  name: "NursingProjectList",
  data() {
    return {
      filteForm: { projectName: "", category: null, status: null, pageNum: 1, pageSize: 20 },
      dataList: [],
      totalDataNumber: 0,
      loading: false,
      dialogVisible: false,
      dialogTitle: "新增护理项目",
      isEdit: false,
      addForm: { gender: "all", defaultDuration: 30, price: 0, status: 1 },
      submitLoading: false
    };
  },
  methods: {
    onSubmit() { this.filteForm.pageNum = 1; this.getTableData(); },
    showAddForm() {
      this.isEdit = false;
      this.dialogTitle = "新增护理项目";
      this.addForm = { gender: "all", defaultDuration: 30, price: 0, status: 1 };
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.isEdit = true;
      this.dialogTitle = "编辑护理项目";
      this.addForm = Object.assign({ price: 0 }, row);
      if (this.addForm.price == null) this.addForm.price = 0;
      this.dialogVisible = true;
    },
    toggleStatus(row) {
      const status = row.status === 1 ? 0 : 1;
      this.$postJson("omc/nursingProject/updateStatus", { id: row.id, status }).then(res => {
        if (res.code == 200) {
          this.$message.success("操作成功");
          this.getTableData();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleDelete(row) {
      this.$confirm("确认删除该护理项目?", "提示", { type: "warning" }).then(() => {
        this.$postJson("omc/nursingProject/delete", { id: row.id }).then(res => {
          if (res.code == 200) {
            this.$message.success("删除成功");
            this.getTableData();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    closeDialog() {
      this.dialogVisible = false;
      this.addForm = { gender: "all", defaultDuration: 30, price: 0, status: 1 };
    },
    submitForm() {
      if (!this.addForm.projectName) return this.$message.warning("请输入项目名称");
      if (!this.addForm.category) return this.$message.warning("请选择项目分类");
      this.submitLoading = true;
      const url = this.isEdit ? "omc/nursingProject/modify" : "omc/nursingProject/add";
      const payload = Object.assign({}, this.addForm, {
        price: this.addForm.price != null && this.addForm.price !== "" ? Number(this.addForm.price) : 0
      });
      this.$postJson(url, payload).then(res => {
        if (!res || typeof res !== "object") {
          this.$message.error("保存失败，请稍后重试");
          return;
        }
        if (res.code == 200 || res.code === "200" || res.status) {
          this.$message.success("保存成功");
          this.closeDialog();
          this.getTableData();
        } else if (res.code != 100010) {
          this.$message.error(res.message || "保存失败");
        }
      }).finally(() => { this.submitLoading = false; });
    },
    getTableData() {
      this.loading = true;
      this.$postJson("omc/nursingProject/queryListWithPage", this.filteForm).then(res => {
        this.dataList = (res.result && res.result.list) ? res.result.list : [];
        this.totalDataNumber = Number(res.result && res.result.total) || 0;
      }).finally(() => { this.loading = false; });
    },
    handleCurrentChange(val) {
      this.filteForm.pageNum = val;
      this.getTableData();
    },
    formatPrice(val) {
      if (val == null || val === "") return "0.00";
      const num = Number(val);
      return isNaN(num) ? "0.00" : num.toFixed(2);
    },
    categoryText(v) {
      const map = { basic: "基础护理", life: "生活照料", medical: "医疗护理", psychological: "心理护理", safety: "安全看护" };
      return map[v] || v;
    },
    genderText(v) {
      const map = { all: "全部", male: "男", female: "女" };
      return map[v] || v;
    },
    tableRowStyle() { return "background-color: #ffffff"; },
    tableHeaderColor({ rowIndex }) {
      if (rowIndex === 0) return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 14px;background-color: #d4f5fa;";
    },
    exportExcel() {
      postDownload("omc/nursingProject/export", "护理项目.xls", this.filteForm);
    },
    downloadTemplate() {
      postDownload("omc/nursingProject/downloadTemplate", "护理项目导入模板.xls", {});
    },
    triggerImport() {
      this.$refs.importFile && this.$refs.importFile.click();
    },
    onImportFile(e) {
      const file = e.target.files[0];
      if (!file) return;
      const fd = new FormData();
      fd.append("file", file);
      this.$postFormData("omc/nursingProject/importExcel", fd).then(res => {
        if (res.code == 200) {
          this.$message.success(res.message || "导入成功");
          this.getTableData();
        } else this.$message.error(res.message);
      });
      e.target.value = "";
    }
  },
  mounted() { this.getTableData(); }
};
</script>
<style lang="scss" scoped>
.buttonlist .buttonlist-m {
  padding: 16px 20px 0;
}
.filter-form {
  padding-bottom: 4px;
}
.action-form {
  padding-bottom: 12px;
  margin-bottom: 4px;
  border-bottom: 1px solid #ebeef5;
}
.table-wrap {
  margin-top: 8px;
}
.price-text {
  color: #e6a23c;
  font-weight: 500;
}
.op-cell {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  gap: 6px;
}
::v-deep .op-cell .el-button + .el-button {
  margin-left: 0;
}
::v-deep .op-cell .el-button--mini {
  padding: 7px 10px;
}
.fenye {
  margin: 0;
  padding: 20px 0;
  background: #fff;
}
</style>
